import React, { Fragment, useCallback } from "react";

import Container from "react-bootstrap/Container";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Badge from "react-bootstrap/Badge";
import { FaSync } from "react-icons/fa";

import LoadingSpinner from "../Layout/LoadingSpinner";
import ColumnHeader from "./ColumnHeader";

import LocationFilters from "./LocationFilters";
import LocationRow from "./LocationRow";

const LocationsTable = ({
    locations,
    fetchLocations,
    sortConfig,
    requestSort,
    selectedLocations,
    handleLocationSelect,
    locationFilters,
    setLocationFilters,
    locationsLoading,
    locationsEmptying,
    locationsRemoving,
    handleEmptySelectedLocations,
    handleRemoveSelectedLocations,
    handleMoveLocationItem,
    handleRemoveLocationItem
}) => {
    const handleSelectAllLocations = useCallback((locations) => {
        const selected = selectedLocations || [];

        if (handleLocationSelect) {
            if (selected.length === locations.length) {
                locations.forEach((location) => {
                    handleLocationSelect(location._id, false);
                });
            } else {
                locations.forEach((location) => {
                    handleLocationSelect(location._id, true);
                });
            }
        }
    }, [handleLocationSelect, selectedLocations]);

    const fields = [
        { name: "Ubicación", id: "name", width: "10%" },
        { name: "Última modificación", id: "updatedAt", width: "10%" },
        { name: "Inventario", id: "inventory", width: "80%" },
    ];

    return (
        <Container fluid>
            <div className="w-100 h-100 p-4 border customFormBox">
                <Button
                    className="float-end ms-2 mt-1 mb-2"
                    onClick={() => fetchLocations()}
                >
                    <FaSync style={{ marginBottom: "3px" }} />
                </Button>
                <Button
                    variant="danger"
                    className="float-end ms-2 mt-1 mb-2"
                    disabled={!selectedLocations.length || locationsEmptying || locationsRemoving}
                    onClick={() => handleRemoveSelectedLocations()}
                >
                        Eliminar ubicaciones
                    {locationsRemoving ? (
                        <Fragment>
                            <Spinner
                                className="ms-2"
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            <span className="visually-hidden">Cargando...</span>
                        </Fragment>
                    ) : (
                        <Badge className="ms-2" bg="light" text="dark">
                            {selectedLocations.length}
                        </Badge>
                    )}
                </Button>

                <Button
                    variant="dark"
                    className="float-end mt-1 mb-2"
                    disabled={!selectedLocations.length || locationsEmptying || locationsRemoving}
                    onClick={() => handleEmptySelectedLocations()}
                >
                        Vaciar ubicaciones
                    {locationsEmptying ? (
                        <Fragment>
                            <Spinner
                                className="ms-2"
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            <span className="visually-hidden">Cargando...</span>
                        </Fragment>
                    ) : (
                        <Badge className="ms-2" bg="light" text="dark">
                            {selectedLocations.length}
                        </Badge>
                    )}
                </Button>

                <h3>Inventario existente</h3>

                <LocationFilters
                    locationFilters={locationFilters}
                    setLocationFilters={setLocationFilters}
                />

                {locationsLoading
                    ? <div className="text-center">
                        <br />
                        <br />
                        <LoadingSpinner />
                    </div>
                    : <Table striped bordered hover>
                        <thead>
                            <tr>
                                {handleLocationSelect ? (
                                    <th style={{ width: "2em" }}>
                                        <Form.Check
                                            id={"all_items"}
                                            type="checkbox"
                                            checked={
                                                selectedLocations.length === locations.length
                                            }
                                            onChange={() =>
                                                handleSelectAllLocations(locations)
                                            }
                                        />
                                    </th>
                                ) : null}

                                {fields.map((header) => (
                                    <ColumnHeader
                                        key={"header_" + header.id}
                                        name={header.name}
                                        id={header.id}
                                        width={header.width}
                                        sortConfig={sortConfig}
                                        requestSort={requestSort}
                                    />
                                ))}
                            </tr>
                        </thead>

                        <tbody>
                            {locations.map((location) => {
                                const selected = selectedLocations
                                    ? selectedLocations.includes(location._id)
                                        ? true
                                        : false
                                    : null;

                                return (
                                    <LocationRow
                                        key={location._id}
                                        location={location}
                                        selected={selected}
                                        fields={fields}
                                        locationFilters={locationFilters}
                                        handleLocationSelect={handleLocationSelect}
                                        handleMoveLocationItem={handleMoveLocationItem}
                                        handleRemoveLocationItem={handleRemoveLocationItem}
                                    />
                                );
                            })}
                        </tbody>
                    </Table>
                }
            </div>

        </Container>
    );
};

export default LocationsTable;